export const version = 'kunde-v1.20.0-SNAPSHOT-af1ddd7298e9d3637a307a46075c92264a35c80b';